import { useContext } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import PropType from 'prop-types';
FavoriteFilter.propTypes = {
	hcpFavoriteCheckbox: PropType.bool.isRequired,
	setHcpFavoriteCheckbox: PropType.func.isRequired,
	includeWrappingRow: PropType.bool,
};

export default function FavoriteFilter({ hcpFavoriteCheckbox, setHcpFavoriteCheckbox, includeWrappingRow }) {
	const [appState] = useContext(AppContext);
	const hcpFavoritesEnabled = getConfigValue(appState.config?.HCP?.Favorites?.Enabled, appState)?.Value === 'true';

	function handleHcpFavoriteCheckBoxClick(event) {
		setHcpFavoriteCheckbox(event.target.checked);
	}
	const content = (
		<div className='form-check mb-3 mb-md-0 me-md-5'>
			<input
				className='form-check-input'
				type='checkbox'
				id='list-filter-favorites'
				checked={hcpFavoriteCheckbox}
				onChange={(event) => handleHcpFavoriteCheckBoxClick(event)}
			></input>
			<label className='form-check-label type-14' htmlFor='list-filter-favorites'>
				{getConfigValue(appState.config?.HCP?.Favorites?.Filter?.Label, appState)?.Value || 'Show only favorites'}
			</label>
		</div>
	);
	return (
		hcpFavoritesEnabled && (
			<>
				{includeWrappingRow && (
					<div className='row my-4'>
						<div className='col-12'>
							<div className='d-flex flex-column flex-md-row justify-content-md-end'>{content}</div>
						</div>
					</div>
				)}
				{!includeWrappingRow && content}
			</>
		)
	);
}
